<template>
    <div class="page">
      <ul class="pagination">
        <li
          :class="['page-item page-prev',{'page-disabled': selectIndex===0}]"
          @click="pagePrev()"
          title="上一页">
          <a>«</a>
        </li>
        <li
          :title="index+1"
          v-for="(item,index) of pageCount" :key="index"
          :class="['page-item', {'page-item-active': index === selectIndex,
          'page-item-jump-prev': index === jumpPrev,
          'page-item-jump-next': index === jumpNext,
          }]"
          @click="chioce(index, $event)"
          v-show ="index==0 || index == pageCount-1 || index === selectIndex || index === selectIndex+1 || index === selectIndex+2 || index === selectIndex+3 || index === selectIndex-1 || index === selectIndex-2 || index === selectIndex-3"
          >
          <a>{{index+1}}</a>
        </li>
        <li
          :class="['page-item page-prev',{'page-disabled': (selectIndex === pageCount-1 || pageCount === 0) }]"
          @click="pageNext()"
          title="下一页">
          <a>»</a>
        </li>
      </ul>
    </div>
</template>
<script>
    export default {
      data(){
        return {
          pageCount: this.pageNum || 0,
          selectIndex: 0,
          jumpPrev: null,
          jumpNext: 3,
        }
      },
      props:{
        pageNum:{
          type: Number,
          default: 5
        },
        isShow:{
          type: Number,
          default: 5
        },
        pageNo:{
          type: Number
        }
      },
      watch:{
        pageNum(newVal,oldVal){
          if (newVal === 1){
            this.selectIndex = 0;
          }
          this.pageCount = newVal;
        }
      },
      methods: {
        chioce(index,ev){
          let reg = /[page\-item\-jump\-prev|page\-item\-jump\-next]/ig;
          let ownClassName = reg.test(ev.target.className);
          if (ownClassName){
            return;
          }
          this.transform(index)
        },
        transform(index){
          this.selectIndex = index
          this.jumpNext = this.selectIndex + 3;
          this.jumpPrev = this.selectIndex - 3;

          if (this.selectIndex +3 === (this.pageCount-1)){
            this.jumpNext = this.pageCount
          }

          if (this.selectIndex -3 === 0){
            this.jumpPrev = -1;
          }
          this.$emit('currageNum', this.selectIndex+1)
        },
        pagePrev(){
          if (this.selectIndex === 0){
            return;
          }
          let num = this.selectIndex - 1;
          this.transform(num)
        },
        pageNext(){
          if (this.selectIndex === this.pageCount-1){
            return;
          }
          let num = this.selectIndex + 1;
          this.transform(num)
        }
      }
    }
</script>
<style lang="less">

  .page{
    margin: 0 0 20px;
    overflow: hidden;
    ul{
      float: right;
      li{
        &.page-item{
          display: inline-block;
          position: relative;
          vertical-align: middle;
          min-width: 32px;
          height: 32px;
          line-height: 30px;
          margin-right: 4px;
          text-align: center;
          list-style: none;
          background-color: #fff;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          cursor: pointer;
          font-family: Arial;
          border: 1px solid #dddee1;
          border-radius: 4px;
          transition: border .2s ease-in-out,color .2s ease-in-out;
          a{
            display: block;
            width: 100%;
            height: 100%;
            text-decoration: none;
            color: #495060;
          }
          &:hover{
            border-color: #2d8cf0;
            a{
              color: #2d8cf0;
            }
          }
        }
        &.page-disabled{
          a{
            color: #ccc;
          }
          &:hover{
            color: #ccc;
            border-color: #dddee1;
            a{
              color: #ccc;
            }
          }
        }
        &.page-item-jump-prev{
          &:hover{
            border-color: #dddee1;
          }
          a{
            display:none;
          }
        }
        &.page-item-jump-next{
          &:hover{
            border-color: #dddee1;
          }
          a{
            display:none;
          }
        }
        &.page-item-jump-next:after,
        &.page-item-jump-prev:after {
          content: "\2022\2022\2022";
          position:absolute;
          top: 0;
          left:0;
          width: 100%;
          display: block;
          letter-spacing: 1px;
          color: #ccc;
          text-align: center;
        }
        &.page-item-active{
          background-color: #2d8cf0;
          border-color: #2d8cf0;
          &:hover{
            a{
              color: #fff;
            }
          }
          a{
            color: #fff;
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pagination/Pagination.vue